import { useTranslate } from '@tolgee/react';
import { Tabs } from 'antd';
import { useState } from 'react';
import { useTradeListContext } from 'views/Conversation/Sider/TradeContext';
import { LoadingOutlined } from '@ant-design/icons';
import Empty from 'components/Empty';
import { TradeComponentDetailComponent } from 'views/Conversation/Sider/TradeComponentDetail';
import { noop } from 'lodash-es';
import styled from '@emotion/styled';

function TradeList() {
  const { t } = useTranslate();

  const { list, loading, conversation } = useTradeListContext();

  const [activeIndex, setActiveIndex] = useState(0);

  if (loading) {
    return <LoadingOutlined />;
  }

  if (list.length === 0 || !conversation) {
    return <Empty />;
  }

  const tabs = (
    <Tabs type="card" activeKey={`${activeIndex}`} onChange={(key) => setActiveIndex(Number(key))}>
      {list.map((_, index) => (
        <Tabs.TabPane key={index} tab={`${t('Entities.订单')} ${index + 1}`} />
      ))}
    </Tabs>
  );

  const activeTrade = list[activeIndex];

  if (!activeTrade) {
    return <></>;
  }

  return (
    <Container>
      {tabs}
      <TradeComponentDetailComponent
        trade={activeTrade}
        conversation={conversation}
        onDetailClose={noop}
        onUpdate={noop}
      />
    </Container>
  );
}

const Container = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  > * {
    flex: 0 0 auto;
  }
  > .ant-tabs {
    margin: 16px 16px 0;
  }
  > div:last-of-type {
    flex: 1 0 0;
  }
`;

export default TradeList;
